(() => {
const q = s => document.querySelector(s);
const layer = q('#UniNavFeedback'), message = q('#UniNavMessage'), main = q('main');
if (!layer) return;
let show, retry, target, pressed, tab, busy;
function reset() {
  clearTimeout(show);
  clearTimeout(retry);
  layer.hidden = true;
  message.disabled = true;
  message.textContent = '';
  if (pressed) pressed.classList.remove('uni-nav-pressed');
  if (tab) {
    tab.classList.remove('uni-nav-pending');
    tab.parentElement.classList.remove('uni-nav-tabs-pending');
  }
  if (main && target) {
    if (busy === null) main.removeAttribute('aria-busy');
    else main.setAttribute('aria-busy', busy);
  }
  target = pressed = tab = null;
}
message.addEventListener('click', () => { if (target) location.assign(target); });
window.addEventListener('pageshow', reset);
window.addEventListener('click', event => {
  const a = event.target.closest('a[href]');
  if (!a || event.defaultPrevented || event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || a.hasAttribute('download') || (a.target && a.target !== '_self') || a.closest('[data-uni-v2-cart],[role=button]')) return;
  const url = new URL(a.href, location.href);
  if (url.origin !== location.origin || (url.pathname === location.pathname && url.search === location.search)) return;
  reset();
  target = url.href;
  busy = main && main.getAttribute('aria-busy');
  const card = a.closest('.uni-v2-card,.uni-mobile-card,.card-wrapper');
  pressed = card || a;
  pressed.classList.add('uni-nav-pressed');
  tab = a.closest('[data-uni-v2-tabs]') ? a : null;
  if (tab) {
    tab.classList.add('uni-nav-pending');
    const row = tab.parentElement;
    row.classList.add('uni-nav-tabs-pending');
    row.scrollLeft += tab.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - tab.offsetWidth) / 2;
  }
  const kind = /\/products\//.test(url.pathname) ? 'opening' : /\/collections\//.test(url.pathname) ? 'loading' : 'generic';
  const title = card && card.querySelector('h3,.card__heading,.uni-v2-card__title');
  let name = (title || a).textContent.trim().replace(/\s+/g, ' ') || a.getAttribute('aria-label') || url.pathname.split('/').pop().replace(/-/g, ' ');
  if (/^(see all|view all|shop |browse |explore )/i.test(name)) name = url.pathname.split('/').pop().replace(/-/g, ' ');
  name = name.charAt(0).toUpperCase() + name.slice(1);
  if (name.length > 65) name = name.slice(0, 62) + '…';
  show = setTimeout(() => {
    const head = q('[data-uni-v2-tabs]') || q('.section-header');
    layer.style.setProperty('--uni-nav-top', Math.max(0, head ? head.getBoundingClientRect().bottom : 0) + 'px');
    layer.dataset.kind = kind;
    layer.hidden = false;
    message.textContent = layer.dataset[kind].replace('__name__', name);
    if (main) main.setAttribute('aria-busy', 'true');
  }, 100);
  retry = setTimeout(() => {
    message.textContent = layer.dataset.retry;
    message.disabled = false;
  }, 8000);
});
})();
